import React, { useState, useEffect, useCallback, useRef } from "react";
import Fade from "@material-ui/core/Fade";
import { withRouter } from "../../Utils/withRouter";
import { getCurrencyListing } from "../../Services/Actions/userActions";
import { getPlanListing } from "../../Services/Actions/planActions";
import PlanDetail from "./PlanDetail";
import { useQuery } from "@tanstack/react-query";
import PlanComparisonModal from "./PlanComparisonModal";
import Loader from "../../Component/Loader";
import ScrollableWidget from "./ScrollWidget";
import NxaFAQNxaMeets from "../NxaFAQNxaMeets";
import { useNavigate } from "react-router-dom";
import NxaMeetsComparisonmodel from "./PlanComparisonModal/NxaMeetsComparison";
import PlanDetailNxaMeets from "./PlanDetailNxaMeets";
import ScrollWidgetNxaMeets from "./ScrollWidgetNxaMeets";
const initialPricingState = {
  selected_members: 1,
  selected_plan_duration: 12,
  selected_currency: "R",
  selected_plan_id: "",
};

function Pricing() {
  const [state, setState] = useState(initialPricingState);
  const [showComparisonModal, setShowComparisonModal] = useState(false);
  const [tabValue, setTab] = useState("meet");
  const [liveChat, setLiveChat] = useState(false);
  const navigate = useNavigate();
  const {
    selected_members,
    selected_plan_duration,
    selected_currency,
    selected_plan_id,
  } = state;
  const handleTabChange = (tab, path) => {
    setTab(tab);
    navigate(path);
  };
  const { data: plans_list = [], isFetching } = useQuery({
    queryKey: ["getPlanListing", selected_members, selected_currency],
    queryFn: () =>
      getPlanListing({
        plan_users: selected_members,
        currency: selected_currency === "R" ? "ZAR" : "USD",
        type: "meet",
      }),
    select: (data) => data?.data || [],
    // keepPreviousData: true,
    // cacheTime: Infinity,
    // refetchOnMount: false,
    // staleTime: Infinity,
  });

  const { data: currency_list = [], isLoading } = useQuery({
    queryKey: ["getCurrencyListing"],
    queryFn: getCurrencyListing,
    select: (data) => data?.data || [],
    cacheTime: Infinity,
    refetchOnMount: false,
  });

  useEffect(() => {
    // Scroll to top and initialize access state
    window.scrollTo(0, 0);
    setState((prevState) => ({
      ...prevState,
      accessState: window.randomString(15, "aA#"),
    }));

    // Attach event listener for live chat

    // Cleanup the event listener when the component is unmounted
  }, []); // Empty dependency array to only run once on mount

  useEffect(() => {
    if (plans_list instanceof Array && !selected_plan_id) {
      plans_list.map((value) => {
        if (value.plan_name.includes("Professional")) {
          setState((prev) => ({ ...prev, selected_plan_id: value?.planID }));
        }
      });
    }
  }, [plans_list?.length]);

  const onPlanSelectHandler = (value) => {
    const { planID, max_user, min_user } = value;
    setState((prev) => ({ ...prev, selected_plan_id: planID }));
  };

  const getSelectedPlanDetails = useCallback(
    ({ plan_id }) => {
      return plans_list.find((item) => item?.planID === plan_id) || null;
    },
    [plans_list]
  );

  const subtractHandler = useCallback(
    (current_selected_members) => {
      const planData = getSelectedPlanDetails({ plan_id: selected_plan_id });
      const { min_user } = planData;

      if (current_selected_members === 1) {
        return;
      } else {
        setState((prev) => ({
          ...prev,
          selected_members: prev.selected_members - 1,
        }));
      }
    },
    [selected_plan_id]
  );

  const addHandler = useCallback(
    (current_selected_members) => {
      const planData = getSelectedPlanDetails({ plan_id: selected_plan_id });
      const { max_user } = planData;

      setState((prev) => ({
        ...prev,
        selected_members: prev.selected_members + 1,
      }));
    },
    [selected_plan_id]
  );

  // Function to open the comparison modal
  const openComparisonModal = () => {
    setShowComparisonModal(true);
  };

  // Function to close the comparison modal
  const closeComparisonModal = () => {
    setShowComparisonModal(false);
  };

  return (
    <>
      <Loader showLoader={isLoading || isFetching} />
      <Fade in={true} timeout={500}>
        <React.Fragment>
          <div className="contact-info">
            <div className="phone-number">087 910 3000</div>

            {/* Triggering live chat popup */}
            <div
              onClick={() => setLiveChat(true)}
              className="live-chat"
              style={{ cursor: "pointer" }}
            >
              <img
                src="..\assets\images\new_pricing\livechat.svg"
                height={40}
                width={40}
                alt="Live Sales Chat"
              />
              <span>Live Sales Chat</span>
            </div>
          </div>
          {liveChat && (
            <div
              className="home-call-popup home-call-fixpop bg--white z-index--9 p--15 radius--16 text-center w--min-290 "
              id="home-call-fixpop"
            >
              <div className="p--relative">
                <span
                  className="close-popup"
                  onClick={() => setLiveChat(false)}
                >
                  <img
                    src={`${"./../assets/images"}/cross-add-modal.svg`}
                    alt="1"
                    className="h--25 w-auto c--pointer"
                  />
                </span>
                <span className=" w--70 h--70 radius--50 overflow-hidden object-fit--cover bg--gray-f5 d-flex align-items-center justiffy-content-center m-auto border--4 border--orange">
                  <img
                    src={`${"./../assets/images"}/home-profile-img.svg`}
                    alt="2"
                  />
                </span>
                <div className="font--24 mt--8 mb--8 text--black sf--d-bold">
                  Welcome to Nxatel
                </div>
                <div
                  className="text--blue-1d3f font--16 bg--light-yellow pt--7 pb--7 pr--10 pl--10 radius--50 c--pointer sf--d-semibold"
                  id="zoho-chat-popup"
                >
                  Speak to our sales team
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      textAlign: "center",
                      flexDirection: "column",
                      marginLeft: "50px",
                    }}
                  >
                    <div className="text--blue-1d3f font--16  dm--sans">
                      Call us on
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="text--blue-1d3f font--20 dm--sans fw--700">
                        086 169 2835
                      </div>{" "}
                    </div>
                  </div>
                  <div>
                    {" "}
                    <a href="https://api.whatsapp.com/send/?phone=27672607763&text&type=phone_number&app_absent=0">
                      <img
                        src="..\assets\images\new_index\whatsapp.svg"
                        height={50}
                        width={50}
                        style={{
                          marginTop: "5px",
                          paddingLeft: "10px",
                        }}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
          <section className="pricing_page_heading">
            <div className="heading">
              Flexible Pricing Plans to Grow with Your Business
            </div>
            <div className="subheading">
              <div className="Dots">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                  >
                    <circle
                      cx="10.1087"
                      cy="9.39191"
                      r="9.39191"
                      fill="#313848"
                    />
                  </svg>
                  <span>No Setup Fees</span>
                </div>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                  >
                    <circle
                      cx="10.1087"
                      cy="9.39191"
                      r="9.39191"
                      fill="#313848"
                    />
                  </svg>
                  <span>Cancel Anytime</span>
                </div>

                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                  >
                    <circle
                      cx="10.1087"
                      cy="9.39191"
                      r="9.39191"
                      fill="#313848"
                    />
                  </svg>
                  <span>Instant Activation</span>
                </div>
              </div>
            </div>
            <div className="button-container">
              <button
                onClick={() => handleTabChange("Bussiness", "/BussinessPhone")}
                className={`button business-phone ${
                  tabValue === "phone" ? "active" : ""
                }`}
              >
                Business Phone
              </button>
              <button
                onClick={() => handleTabChange("One", "/Pricing")}
                className={`button business-phone ${
                  tabValue === "one" ? "active" : ""
                }`}
              >
                Nxa Tel One
              </button>
              <button
                onClick={() => handleTabChange("Video", "/NxaMeets")}
                className={`button business-phone ${
                  tabValue === "meet" ? "active" : ""
                }`}
              >
                NxaMeets Video
              </button>
            </div>
          </section>

          <div className="pricing-step pricing-signup pricing-page">
            <section style={{ marginBottom: "48px" }}>
              {" "}
              <div className="pricing-after pricing-box-section pt-5">
                <div className="container">
                  <div className="Steps-price pricing-page">
                    <div className="row">
                      <div className="col-md-6">
                        <span className="font--16 text--black fw--700 pl-90  mb-1 d-inline-block w-10">
                          How many members is your Team?
                        </span>
                        <div className="Size-team">
                          <>
                            <div className="d-flex gap--12">
                              <button
                                onClick={() =>
                                  subtractHandler(selected_members)
                                }
                                className="border--none btn btn--orange radius--50 w--50 h--50 font--24"
                              >
                                -
                              </button>
                              <button
                                style={{ backgroundColor: "#252B42" }}
                                className="radius--8 text--white border--none bg--black w--65 h--50"
                                disabled
                              >
                                {selected_members}
                              </button>
                              <div className="tooltip-container">
                                <button
                                  onClick={() => addHandler(selected_members)}
                                  className="border--none btn btn--orange radius--50 w--50 h--50 "
                                >
                                  +
                                </button>
                                <div className="custom-tooltip">
                                  Add more team members?
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                      <div>
                        <div
                          className="btn-group btn-group-pricing "
                          role="group"
                          aria-label="Basic example"
                        >
                          <button
                            type="button"
                            className={`btn btn-secondary ${
                              selected_plan_duration === 1 ? "active" : ""
                            }`}
                            onClick={() =>
                              setState((prev) => ({
                                ...prev,
                                selected_plan_duration: 1,
                              }))
                            }
                          >
                            Monthly
                          </button>
                          <button
                            type="button"
                            className={` btn btn-secondary ${
                              selected_plan_duration === 12 ? "active" : ""
                            }`}
                            onClick={() =>
                              setState((prev) => ({
                                ...prev,
                                selected_plan_duration: 12,
                              }))
                            }
                          >
                            Annually
                            <br /> Save Up to 18%
                          </button>
                          <button
                            type="button"
                            className={`btn btn-secondary ${
                              selected_plan_duration === 24 ? "active" : ""
                            }`}
                            onClick={() =>
                              setState((prev) => ({
                                ...prev,
                                selected_plan_duration: 24,
                              }))
                            }
                          >
                            24-Month <br />
                            Save Up to 20%
                          </button>
                        </div>
                      </div>
                      <div
                        className="form-group currency currency-div   col-md-2"
                        style={{
                          textAlign: "right",
                          justifyContent: "flex-end",
                        }}
                      >
                        <select
                          className="form-control "
                          style={{
                            borderRadius: " 9px",
                            border: "2px solid #FFD166",
                          }}
                          id="exampleFormControlSelect1"
                          name="selected_currency"
                          value={selected_currency}
                          onChange={(e) =>
                            setState((prev) => ({
                              ...prev,
                              selected_currency: e.target.value,
                            }))
                          }
                        >
                          <option value="" disabled selected>
                            Currency
                          </option>
                          {currency_list &&
                            currency_list.map((value, index) => {
                              return (
                                <option key={index} value={value.symbol}>
                                  {value.currencyCode}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div className="row">
              <div className="col-md-12">
                <div className="pricing pricing-palden">
                  <PlanDetailNxaMeets
                    plans_list={plans_list}
                    state={state}
                    onPlanSelectHandler={onPlanSelectHandler}
                  />
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-md-6 free-trial-div">
                  <h5 className="12 color-696871 fw--400">
                    Your 14-day Free Trial includes:
                  </h5>
                  <span className="font--10">
                    - Full use of the Nxatel cloud phone system for up to 14
                    days
                    <br /> - Maximum of 3 users <br />- 20 min talk time per
                    user
                    <br /> - 3 SMS <br /> - 1 Business Landline number
                  </span>
                </div>
                <div className="col-md-6">
                  <div className="still-not-sure d-flex align-items-center justify-content-end gap--12">
                    <h4 className="mb-0 font--32 fw--400">Still not sure?</h4>
                    <span
                      className="btn bg--orange border--orange pt--5 pb--5 pr--20 pl--20 radius--8 font--15 text--white dm--sans fw--700"
                      onClick={() => setShowComparisonModal(true)}
                    >
                      Compare All Features{" "}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Trusted companies */}
          <div className="banner-bottom-client z-index--1 p--relative ">
            <div className="container">
              <div className="text--gray-5b7d text-center mt--25 sf--d-bold font--18 mb--15">
                TRUSTED BY OVER 1000+ COMPANIES
              </div>
              <div className="  d-flex align-items-center   flex-wrap justify-content-around">
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\beckers.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\sasol.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\mediwell.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\specsaver.svg"
                      className="img-fluid  p--8 c--pointer"
                      s
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\png.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\Torga.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\whitestone.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
                <span className="company-logo  text-center">
                  <a href={void 0}>
                    <img
                      src="..\assets\images\new_index\Trusted Companies\spar.svg"
                      className="img-fluid  p--8 c--pointer"
                      alt="1"
                    />
                  </a>
                </span>
              </div>
              <div
                className="text-center font--20 mb-0 text--black sf--d-medium mt--15
    "
              >
                No contract. No set-up Fees. One Provider for everything. Easy
                to scale. Work from Home Ready​​
              </div>
            </div>
          </div>
          {/* Why Choose Nxatel */}
          <section
            className="switch-nxa-sec
           "
            style={{ marginTop: "40px" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className=" text-center text--black font--36 lh--42 sf--d-semibold   font--sm-30 mb--8 lh--sm-42">
                    Why Choose NxaMeets?
                  </div>
                  <div className="pt--50">
                    <div className="row">
                      <div className="col-md-4">
                        <div
                          className="switch-nxa-card p--20 bg--white mb--50 h--min-225 mt--10"
                          style={{
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "15px",
                          }}
                        >
                          <span className="card-circle w--75 h--75 radius--50 bg--orange d-flex align-items-center justify-content-center ">
                            <img
                              src={`${"./../assets/images"}/wn-1.svg`}
                              className=" h--44 w-auto"
                              alt="1"
                            />
                          </span>
                          <div className="text--blue-1d3f font--20 lh--28 sf--t-medium fw--700 mb--5 text-center pb-4">
                            Instant Set-Up
                          </div>
                          <div className="text--gray-7c87 font--16 lh--25 dm-sans text-center">
                            Activate in just 3 minutes, no hardware required.
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="switch-nxa-card p--20 bg--white mb--50 h--min-225 mt--10"
                          style={{
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "15px",
                          }}
                        >
                          <span className="card-circle w--75 h--75 radius--50 bg--orange d-flex align-items-center justify-content-center ">
                            <img
                              src={`${"./../assets/images"}/wn-2.svg`}
                              alt="1"
                              className="h--36 w-auto"
                            />
                          </span>
                          <div className="text--blue-1d3f font--20 lh--28 sf--t-medium fw--700 mb--5 text-center pb-4">
                            Flexiable & Scalable
                          </div>
                          <div className="text--gray-7c87 font--16 lh--25 dm-sans text-center">
                            Upgrade, downgrade, or customise as your bussiness
                            grows.
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div
                          className="switch-nxa-card p--20 bg--white mb--50 h--min-225 mt--10"
                          style={{
                            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                            borderRadius: "15px",
                          }}
                        >
                          <span className="card-circle w--75 h--75 radius--50 bg--orange d-flex align-items-center justify-content-center ">
                            <img
                              src={`${"./../assets/images"}/wn-3.svg`}
                              alt="1"
                              className="h--36 w-auto"
                            />
                          </span>
                          <div className="text--blue-1d3f font--20 lh--28 sf--t-medium fw--700 mb--5 text-center pb-4">
                            Enterprise-Grade Security
                          </div>
                          <div className="text--gray-7c87 font--16 lh--25 dm-sans text-center">
                            Fully compliant with POPIA, GDPR, and other global
                            security standards.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* ----- */}
          <section className="scroll" style={{ marginBottom: "90px" }}>
            <ScrollWidgetNxaMeets /> {/* Include the scrollable widget here */}
          </section>

          <NxaFAQNxaMeets />
          <div
            class="cta-section"
            style={{
              backgroundImage:
                "url('/assets/images/new_pricing/background_banner.svg')", // Adjust the path as needed
              backgroundSize: "cover",
              backgroundPosition: "center",
              textAlign: "center",
              padding: "50px 20px",
              color: "white",
              fontFamily: "Arial, sans-serif",
            }}
          >
            <div class="cta-content">
              <h1>Start Using NxaTel for Free</h1>
              <p
                style={{
                  color: "white",
                }}
              >
                Still not sure? Try our 14-day free trial and experience the
                difference!
              </p>
              <div class="cta-buttons">
                <div className="d-flex justify-content-center gap--15 mt--15">
                  {" "}
                  <a
                    href="/signup"
                    className="btn  bg--red-f037 text--white border--2 border--red-f037 sf--t-medium radius--16-0"
                  >
                    Try for free
                  </a>
                  <a
                    href=""
                    className="btn  bg--transparent text--white border--2 border--white sf--t-medium radius--16-0"
                  >
                    Compare Prices
                  </a>
                </div>
              </div>
            </div>
          </div>
        </React.Fragment>
      </Fade>
      <NxaMeetsComparisonmodel
        setShowComparisonModal={setShowComparisonModal}
        showComparisonModal={showComparisonModal}
        plans_list={plans_list}
      />
    </>
  );
}

export default withRouter(Pricing);
